@if (loading) {
  <app-spinner [message]="''" />
}

@if (!loading) {
  @for (rootGroup of groupsTree; track rootGroup._id) {
    <app-list-item
      [selected]="isSelected(rootGroup)"
      [hasMenu]="true"
      (click)="selectGroup(rootGroup)"
    >
      <mat-icon itemIcon>folder</mat-icon>
      <span itemTitle>{{ rootGroup.name }}</span>
      <ng-container itemSuffix>
        <span class="item-count">{{ rootGroup.itemCount || 0 }}</span>
        @if (rootGroup.approved) {
          <mat-icon class="approval-tick" matTooltip="Approved">check_circle</mat-icon>
        }
      </ng-container>
      <ng-container itemMenu>
        <button mat-menu-item (click)="openCreateGroupModal(rootGroup)">
          <mat-icon>add</mat-icon>
          <span>Add child group</span>
        </button>
        <button mat-menu-item (click)="openEditGroupModal(rootGroup, $event)">
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>
        <button mat-menu-item (click)="openDeleteGroupModal(rootGroup, $event)">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      </ng-container>
    </app-list-item>

    @if (rootGroup.children.length > 0) {
      <div class="context-tree-branch">
        @for (childGroup of rootGroup.children; track childGroup._id) {
          <app-list-item
            [selected]="isSelected(childGroup)"
            [hasMenu]="true"
            (click)="selectGroup(childGroup)"
          >
            <span itemTitle>{{ childGroup.name }}</span>
            <ng-container itemSuffix>
              <span class="item-count">{{ childGroup.itemCount || 0 }}</span>
              @if (childGroup.approved) {
                <mat-icon class="approval-tick" matTooltip="Approved">check_circle</mat-icon>
              }
            </ng-container>
            <ng-container itemMenu>
              <button mat-menu-item (click)="openEditGroupModal(childGroup, $event)">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="openDeleteGroupModal(childGroup, $event)">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </ng-container>
          </app-list-item>
        }
      </div>
    }
  }
}

@if (!loading && groupsTree.length === 0) {
  <p class="empty-indicator">No context groups yet</p>
}
